import { render, staticRenderFns } from "./PostCreateButton.vue?vue&type=template&id=1fbbe0d6&"
import script from "./PostCreateButton.vue?vue&type=script&lang=js&"
export * from "./PostCreateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports